import { Component, OnInit } from '@angular/core';
import { LogincacheService } from '../../../../../graphqlserver/logincache.service';
import {User} from '../../../../../modules/principal/models/usermodel';
import{Router}from '@angular/router';

import {global} from '../../../../../graphqlserver/conection';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { KardexService } from "../../../../../modules/kardex/services/kardex.service";
import { UsuarioService } from "../../../../../modules/complemento/services/usuario.service";
import { Usuario } from "../../../../../modules/complemento/models/usuarios";
import {SnotifyService,SnotifyPosition,SnotifyStyle} from 'ng-snotify';
import CryptoES from 'crypto-es';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

  public fotografia:string='assets/mingob/avatar.jpg'
  public habilitar:boolean=false;

  public formData = new FormData();

  public claveactual:string='';
  public clavenueva1:string='';
  public clavenueva2:string='';
  public clave:string='';
  public url: any;

  public perfil:User;
  public ci:string='';
  public m_usuario:Usuario=new Usuario();
  constructor(private snotifyService: SnotifyService, private usuarioService: UsuarioService,private usercache:LogincacheService,private router:Router,private modalService: NgbModal, private kardexService: KardexService,) { }

  ngOnInit() {
    this.perfil=this.usercache.getUserLoggedIn();
    this.ci=this.perfil.idcarnet;
    if(this.perfil.fotografia!=null && this.perfil.fotografia!=''){
      let cipher=(CryptoES.AES.encrypt(this.perfil.fotografia, global.secret)).toString();
      let safeCipher = cipher
  .replace(/\+/g, '-') // + por -
  .replace(/\//g, '_') // / por _
  .replace(/=+$/, ''); // Eliminar el relleno Base64 (=)
      this.fotografia=global.urlgraph+'/profile/'+encodeURIComponent(safeCipher);
    }
    if(Object.entries(this.perfil.permisos).length==0){
      this.habilitar=false;
    }else{
      this.habilitar=true;
    }
    this.listaUsuarios(this.ci);
  }

  onLogout(event) {
    event.preventDefault();
    localStorage.removeItem('token');
    localStorage.removeItem('x-key');
    localStorage.removeItem('info');
    localStorage.removeItem('frrhh');
    this.router.navigateByUrl('/sigrrhh/principal/login');
  }

  public refereshphoto(){
    this.perfil=this.usercache.getUserLoggedIn();
    if(this.perfil.fotografia!=null && this.perfil.fotografia!=''){
      let cipher=(CryptoES.AES.encrypt(this.perfil.fotografia, global.secret)).toString();
      let safeCipher = cipher
  .replace(/\+/g, '-') // + por -
  .replace(/\//g, '_') // / por _
  .replace(/=+$/, ''); // Eliminar el relleno Base64 (=)
      this.fotografia=global.urlgraph+'/profile/'+encodeURIComponent(safeCipher);
    }
  }

  async listaUsuarios(ci:string){
    await this.usuarioService.listausuarios(ci).subscribe(
      res=>{
        this.m_usuario=res[0];
      },
      err=>{console.error(err);}
    );
  }

  async actualizaUsuario(dato:Usuario) {
    await this.usuarioService.changePassword(dato.idcarnet, dato.clave).subscribe(
      res => {
        if (res && res.success) {
          this.snotifyService.success('La contraseña fue cambiada', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position: SnotifyPosition.rightTop
          });
          localStorage.removeItem('token');
          localStorage.removeItem('x-key');
          localStorage.removeItem('frrhh');
          localStorage.removeItem('info');
          this.router.navigateByUrl('/sigrrhh/principal/login');
        } else {
          this.snotifyService.warning(res.message || 'No se pudo cambiar la contraseña', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position: SnotifyPosition.rightTop
          });
        }
      },
      err => {
        console.error(err);
        const errorMsg = err.error?.message || err.error?.error || 'Ocurrio un error al cambiar la contraseña';
        this.snotifyService.error(errorMsg, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position: SnotifyPosition.rightTop
        });
      }
    );
  }


  MensajeMutation(datom:any){
    if(datom){
      if(datom[0].res.valor==1){
        this.snotifyService.success('La contraseña fue cambiada', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position:SnotifyPosition.rightTop
        });
        localStorage.removeItem('token');
        localStorage.removeItem('x-key');
        localStorage.removeItem('frrhh');
        localStorage.removeItem('info');
        this.router.navigateByUrl('/sigrrhh/principal/login');
      }else{
        this.snotifyService.warning(datom[0].res.mensaje, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position:SnotifyPosition.rightTop
        });
      }
    }else{
      this.snotifyService.error('Ocurrio un error en la transacción de datos', {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        icon: 'assets/mingob/notify.png',
        position:SnotifyPosition.rightTop
      });
    }
  }

  open(content) {
    this.claveactual='';
    this.clavenueva1='';
    this.clavenueva2='';
    this.clave='';
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        var bytes = CryptoES.AES.decrypt(this.m_usuario.clave, global.secret);
		    this.clave = bytes.toString(CryptoES.enc.Utf8);
        if(this.clave==this.claveactual){
          if(this.clavenueva1==this.clavenueva2){
            this.m_usuario.clave=this.clavenueva1;
            this.actualizaUsuario(this.m_usuario);
          }else{
            this.snotifyService.error('ERROR, Las contraseñas nuevas no coinciden', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              icon: 'assets/mingob/notify.png',
              position:SnotifyPosition.rightTop
            });
          }
        }else{
          this.snotifyService.error('ERROR. La contraseña actual, no es correcta', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position:SnotifyPosition.rightTop
          });
        }
    }, () => {});
  }

  open2(content2) {
      this.modalService.open(content2, {ariaLabelledBy: 'modal-basic-title',size:'sm'}).result.then((result) => {
        this.guardafotografia();
    }, () => {});
  }

      //FileUpload
      async readUrl(event: any) {
        if (event.target.files.length === 0)
          return;
        //Image upload validation
        var mimeType = event.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
          return;
        }
        // Image upload
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.url = reader.result;
        }
  //para cargar
        this.formData = new FormData();
        this.formData.append('fotoHV',event.target.files[0]);
        //this.hojaVidaObj.fotografia=this.fotografia.name;

      }

      async guardafotografia(){
        await this.kardexService.photoupload(this.formData,this.perfil.idcarnet).subscribe(
          res=>{
            var dato:any=res;
            this.perfil.fotografia=(dato.message);
            this.usercache.setUserLoggedIn(this.perfil);

            this.snotifyService.success('La fotografia fue actualizada', {
              timeout: 1000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              icon: 'assets/mingob/notify.png',
              position:SnotifyPosition.rightTop
            });
            setTimeout(() => {
              location.reload();
            }, 1000);

            //console.log(this.hojaVidaObj.fotografia);
          },
          err=>{console.error(err);}
        );
      }

}
